module.exports = __webpack_public_path__ + "public/images/generated-spanish-immersion.78ef7fe0931200895adbcfb6c9817491.jpg";